import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

function normalise_phone_number(number: string): string {
	return number.replace(/^\+27/, '0')
}

export class Reservation {
	token: string;
	rate: number;
	created: Date;
	full_name: string;
	move_in: Date;
	description: string;
	size: string;
	site_id: number;
}

@Injectable({
	providedIn: 'root'
})
export class ReservationService {

	private generic_error_message = "Sorry, we were unable to reserve your unit at this time. Please try again later, or call 0861\u201173\u201168\u201127 for assistance."

	constructor(private http: HttpClient) { }

	query(Cellphone: string, site_id?: number): Promise<Reservation[]> {
		return new Promise((resolve, reject) => {
			if (!Cellphone || Cellphone.length == 0) {
				reject("No phone number given")
				return
			} else {
				this.http
				.get<any>(`${environment.portalBaseUrl}/api/staff/reservation`, {
					params: {
						cell: normalise_phone_number(Cellphone)
					}
				})
				.toPromise()
				.then(response => {
					let reservations: Reservation[] = []
					if (response) for (let item of response) {
						let reservation: Reservation = {
							token: item.token,
							rate: item.rate,
							created: new Date(item.created),
							move_in: new Date(item.move_in),
							full_name: item.full_name,
							size: item.size,
							description: item.description,
							site_id: item.site_id
						}

						if (site_id == undefined || site_id == item.site_id) {
							reservations.push(reservation)
						}
					}
					resolve(reservations)
				}, reason => reject("Could not query reservations"))
			}
		})
	}

	reserve(
		UnitItemTypeID: number,
		Firstname: string,
		Surname: string,
		Cellphone: string,
		Email: string,
		ID_Number: string,
		is_business: boolean,
		MoveInDate: Date,
		BranchID: number,
		BranchName: string
	): Promise<string> {
		return new Promise((resolve, reject) => {
			this.http
			.post<any>(`${environment.portalBaseUrl}/api/staff/reservation`, {
				'unit_type_id': UnitItemTypeID,
				'first_name': Firstname,
				'surname': Surname,
				'cell_number': normalise_phone_number(Cellphone),
				'email': Email,
				'move_in_date': MoveInDate,
				'id_number': ID_Number,
				'is_business': is_business,
				'branch_id': BranchID,
				'branch_name': BranchName
			})
			.toPromise()
			.then(response => {
				if (response.error) {
					console.log("Reservation service: error", response.error.text)
					reject(this.generic_error_message)
				} else if (response.token) {
					// Portal returns clean response without PHP warnings
					resolve(response.token)
				}
				else {
					console.log("Reservation service: unhandled response", typeof response, response)
					reject(this.generic_error_message)
				}
			}, reason => reject(this.generic_error_message))
		})
	}

	cancel(token) {
		return new Promise((resolve, reject) => {
			this.http
			.request(
				'delete',
				`${environment.portalBaseUrl}/api/staff/reservation`,
				{
					body: {
						'token': token,
					}
				}
			)
			.toPromise()
			.then((response: any) => {
				if (response.result && response.result == 'success' && response.token) {
					resolve(response.token)
				} else if (response.result && response.result == 'error' && response.error_text) {
					console.log("Error canceling reservation: ", response.error_text)
					reject(this.generic_error_message)
				} else {
					console.log("Error canceling reservation: unhandled response", typeof response, response)
					reject(this.generic_error_message)
				}
			}, reason => reject(this.generic_error_message))
		})
	}
}
